import { useLocation } from "react-router-dom";
import { DEFAULT_ROUTES, DEMO_ROUTES } from "./constants";

/**
 * Hook reativo que devolve o mapa de rotas correto (demo ou padrão) com base
 * no pathname atual. Ao contrário do `ROUTES` estático, é recalculado a cada
 * render — use-o em qualquer lógica que precise ser correta quando o prefixo
 * de rota muda (ex: guardiões de componentes, testes jsdom que iniciam em '/').
 */
export function useActiveRoutes() {
  const { pathname } = useLocation();
  return pathname.startsWith(DEMO_ROUTES.INDEX) ? DEMO_ROUTES : DEFAULT_ROUTES;
}
